import EventCard from "@/components/ui/EventCard";
import { events } from "@/mocks/events";

export default function RelatedEvents({ current }: { current: string }) {
  const pick: string[] = [];
  const cur = events.find((e) => e.slug === current);
  if (cur) {
    cur.related.forEach((s) => {
      if (!pick.includes(s) && s !== current) pick.push(s);
    });
  }
  events.forEach((e) => {
    if (!pick.includes(e.slug) && e.slug !== current && pick.length < 3) pick.push(e.slug);
  });
  const list = pick.slice(0, 3)
    .map((s) => events.find((e) => e.slug === s))
    .filter(Boolean) as typeof events;

  return (
    <section>
      <h2 className="flex items-center gap-2.5 font-heading text-xl font-black text-foreground-950 md:text-2xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50">
          <i className="ri-road-map-line" aria-hidden="true"></i>
        </span>
        相关事件地图
      </h2>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((e) => (
          <EventCard key={e.slug} event={e} />
        ))}
      </div>
    </section>
  );
}